export class EntBasicHB {
  id: number = 0;
  nameRu: string = "";
  nameKy: string = "";
}
